import { COUNTRIES, ZONES } from '@types';

const LOCATIONS_FR = {
  ARLES: { zone: ZONES.EUROPE, country: COUNTRIES.FR, city: 'Arles' },
  FONTENAY: {
    zone: ZONES.EUROPE,
    country: COUNTRIES.FR,
    city: 'Fontenay aux Roses',
  },
  PARIS: { zone: ZONES.EUROPE, country: COUNTRIES.FR, city: 'Paris' },
};

const LOCATIONS_IT = {
  BOLOGNA: { zone: ZONES.EUROPE, country: COUNTRIES.IT, city: 'Bologna' },
  MILAN: { zone: ZONES.EUROPE, country: COUNTRIES.IT, city: 'Milan' },
  ROME: { zone: ZONES.EUROPE, country: COUNTRIES.IT, city: 'Rome' },
};

const LOCATIONS_ASIA = {
  ANGKOR: { zone: ZONES.ASIA, country: COUNTRIES.KH, city: 'Angkor' },
  BANGKOK: { zone: ZONES.ASIA, country: COUNTRIES.TH, city: 'Bangkok' },
  GEORGETOWN: {
    zone: ZONES.ASIA,
    country: COUNTRIES.MY,
    region: 'Penang',
    city: 'Georgetown',
  },
  KUALA_LUMPUR: {
    zone: ZONES.ASIA,
    country: COUNTRIES.MY,
    city: 'Kuala Lumpur',
  },
  PENANG: { zone: ZONES.ASIA, country: COUNTRIES.MY, region: 'Penang' },
  PHNOM_PENH: { zone: ZONES.ASIA, country: COUNTRIES.KH, city: 'Phnom Penh' },
  SIEM_REAP: { zone: ZONES.ASIA, country: COUNTRIES.SG, city: 'Siem Reap' },
  SINGAPORE: { zone: ZONES.ASIA, country: COUNTRIES.SG, city: 'Singapore' },
};

const LOCATIONS_EUROPE = {
  BERLIN: { zone: ZONES.EUROPE, country: COUNTRIES.DE, city: 'Berlin' },
  BUDAPEST: { zone: ZONES.EUROPE, country: COUNTRIES.HU, city: 'Budapest' },
  COPENHAGEN: { zone: ZONES.EUROPE, country: COUNTRIES.DK, city: 'Copenhagen' },
};

export const LOCATIONS = {
  ...LOCATIONS_FR,
  ...LOCATIONS_IT,
  ...LOCATIONS_ASIA,
  ...LOCATIONS_EUROPE,
};
